/** X-window options for OCPP msg/s and Ethernet traffic charts (independent per chart). */
export const OCPP_TRAFFIC_RANGES = ["5m", "15m", "1h", "6h", "24h", "all"] as const;
export type OcppTrafficRange = (typeof OCPP_TRAFFIC_RANGES)[number];
export const OCPP_TRAFFIC_DEFAULT_RANGE: OcppTrafficRange = "15m";

/** /ocpp page — OCPP msg/s trace mode default. */
export const OCPP_MSG_RATE_DEFAULT_MODE = "all" as const;

export function ocppTrafficRangeToMs(range: OcppTrafficRange): number | null {
  switch (range) {
    case "5m":
      return 5 * 60 * 1000;
    case "15m":
      return 15 * 60 * 1000;
    case "1h":
      return 60 * 60 * 1000;
    case "6h":
      return 6 * 60 * 60 * 1000;
    case "24h":
      return 24 * 60 * 60 * 1000;
    case "all":
      return null;
  }
}

/** 1s eth history buckets (integrated from ~100ms wire samples). */
export const ETH_BPS_HISTORY_SAMPLE_MS = 1_000;
